/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_File_Too_LargeInputs */

const en_mobile_upload_error_file_too_large = /** @type {(inputs: Mobile_Upload_Error_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file is too large to upload.`)
};

const es_mobile_upload_error_file_too_large = /** @type {(inputs: Mobile_Upload_Error_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este archivo es demasiado grande para subirlo.`)
};

/**
* | output |
* | --- |
* | "This file is too large to upload." |
*
* @param {Mobile_Upload_Error_File_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_file_too_large = /** @type {((inputs?: Mobile_Upload_Error_File_Too_LargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_File_Too_LargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_file_too_large(inputs)
	return en_mobile_upload_error_file_too_large(inputs)
});